module.exports = __webpack_public_path__ + "img/icon-arrow-more-works.e21fd1d1.svg";